type MetaPixelCommand = "init" | "track";
type MetaPixelParams = Record<string, string | number | boolean | null | undefined>;
type MetaPixelFn = (
  command: MetaPixelCommand,
  eventOrId: string,
  params?: MetaPixelParams,
  eventOptions?: { eventID?: string },
) => void;

type MetaPixelWindow = Window & {
  fbq?: MetaPixelFn;
};

function getFbq(): MetaPixelFn | null {
  if (typeof window === "undefined") return null;

  const fbq = (window as MetaPixelWindow).fbq;
  return typeof fbq === "function" ? fbq : null;
}

function randomId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function newFbLeadEventId(): string {
  return `lead_${randomId()}`;
}

export function newFbCompleteRegistrationEventId(): string {
  return `reg_${randomId()}`;
}

function readCookiePair(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  const raw = match?.[1];
  if (!raw) return undefined;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/** Meta browser cookies for CAPI / pixel matching (first-party on app host). */
export function readFbPixelCookies(): { fbp?: string; fbc?: string } {
  const fbp = readCookiePair("_fbp");
  const fbc = readCookiePair("_fbc");
  return {
    ...(fbp ? { fbp } : {}),
    ...(fbc ? { fbc } : {}),
  };
}

export function trackMetaPixelPageView(): void {
  getFbq()?.("track", "PageView");
}

export function trackMetaPixelLead(eventId?: string): void {
  const fbq = getFbq();
  if (!fbq) return;
  if (eventId) {
    fbq("track", "Lead", {}, { eventID: eventId });
  } else {
    fbq("track", "Lead");
  }
}

export function trackMetaPixelCompleteRegistration(eventId?: string): void {
  const fbq = getFbq();
  if (!fbq) return;
  const params: MetaPixelParams = {
    value: 0,
    currency: "KZT",
  };
  if (eventId) {
    fbq("track", "CompleteRegistration", params, { eventID: eventId });
  } else {
    fbq("track", "CompleteRegistration", params);
  }
}
